// API Configuration
export const API_BASE_URL = 'https://api.talkida.co.in'

// Authentication Endpoints
export const AUTH_ENDPOINTS = {
  LOGIN: '/api/login',
  REGISTER: '/api/register',
  LOGOUT: '/api/logout',
  REFRESH: '/api/token/refresh',
  FORGOT_PASSWORD: '/api/forgot-password',
  RESET_PASSWORD: '/api/reset-password',
  VERIFY_EMAIL: '/api/verify-email'
}

export const SUBSCRIPTION_ENDPOINTS = {
  SUBSCRIPTION_CRUD: '/api/subscription_plans',
  SUBSCRIPTION_CHECK: '/api/subscription',
  PAYMENT: '/api/payment',
}

export const WIDGET_ENDPOINTS = {
  MODEL_CRUD: '/api/model',
  DOCUMENT_UPLOAD: '/api/documents/upload',
  DOCUMENTS_LIST: '/api/documents',
  DOCUMENT_DELETE: (id) => `/api/documents/${id}`,
  CHATBOT_AVATAR_UPLOAD: '/api/model/chabot-avatar-img',
  DOCUMENT_CONTENT: (id) => `/api/documents/${id}/content`,
  DOCUMENT_EDIT: (id) => `/api/documents/${id}/edit`,
  BOT_CREDS: '/api/bot_creds',
}

export const LEADS_ENDPOINTS = {
  LEADS_LIST: '/api/leads',
}

// Chatbot websocket Endpoints
export const CHATBOT_WEBSOCKET_ENDPOINTS = {
  MESSAGE: '/api/ws/chat'
}


// Analytics Endpoints
export const ANALYTICS_ENDPOINTS = {
  DASHBOARD: '/analytics/dashboard',
  CONVERSATIONS: '/analytics/conversations',
  PERFORMANCE: '/analytics/performance',
  USERS: '/analytics/users',
  EXPORT: '/analytics/export'
}

// Team Management Endpoints
export const TEAM_ENDPOINTS = {
  MEMBERS: '/team/members',
  INVITE: '/team/invite',
  ROLES: '/team/roles',
  PERMISSIONS: '/team/permissions'
}

// Settings Endpoints
export const SETTINGS_ENDPOINTS = {
  PROFILE: '/settings/profile',
  ACCOUNT: '/settings/account',
  BILLING: '/settings/billing',
  INTEGRATIONS: '/settings/integrations',
  API_KEYS: '/settings/api-keys'
}

// Webhook Endpoints
export const WEBHOOK_ENDPOINTS = {
  LIST: '/webhooks',
  CREATE: '/webhooks',
  GET: (id) => `/webhooks/${id}`,
  UPDATE: (id) => `/webhooks/${id}`,
  DELETE: (id) => `/webhooks/${id}`,
  TEST: (id) => `/webhooks/${id}/test`
}

// File Upload Endpoints
export const UPLOAD_ENDPOINTS = {
  DOCUMENTS: '/upload/documents',
  IMAGES: '/upload/images',
  AVATARS: '/upload/avatars',
  TRAINING_DATA: '/upload/training-data'
}

// API Headers
export const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
})

export const getFileUploadHeaders = (token) => ({
  'Authorization': `Bearer ${token}`
})

// Request Timeouts
export const REQUEST_TIMEOUTS = {
  DEFAULT: 10000,
  UPLOAD: 30000,
  CHAT: 15000,
  ANALYTICS: 20000
}

// Pagination
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100
}

// Rate Limiting
export const RATE_LIMITS = {
  CHAT_MESSAGES: 100, // per minute
  API_CALLS: 1000, // per hour
  UPLOADS: 10 // per hour
}
